import { useAppDispatch, useAppSelector } from 'hooks';
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { initializeScoring } from 'store/scoring';
import Scoring from '../components/Scoring/Scoring';
import { View, viewAuthorizedRoles } from '../constants';

export default function ScoringView() {
  const role = useAppSelector((state) => state.general.role);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(initializeScoring());

    const interval = window.setInterval(() => {
      dispatch(initializeScoring());
    }, 60 * 1000);

    return () => window.clearInterval(interval);
  }, []);

  if (!role) {
    return null;
  }

  if (!viewAuthorizedRoles[View.grading].includes(role)) {
    return <Navigate to={'/'} />;
  }

  return <Scoring />;
}
